import { render, staticRenderFns } from "./AutoEnrollment.vue?vue&type=template&id=3d56a92a&"
import script from "./AutoEnrollment.vue?vue&type=script&lang=js&"
export * from "./AutoEnrollment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports